/**
 * Curated tag color palette. Hex values match the Tailwind 500 shades for visual
 * coherence with the rest of the UI. The first entry is the default for new tags.
 */
export const TAG_COLORS = [
  { name: 'slate', hex: '#64748b' },
  { name: 'red', hex: '#ef4444' },
  { name: 'orange', hex: '#f97316' },
  { name: 'amber', hex: '#f59e0b' },
  { name: 'green', hex: '#10b981' },
  { name: 'teal', hex: '#14b8a6' },
  { name: 'blue', hex: '#3b82f6' },
  { name: 'violet', hex: '#8b5cf6' },
  { name: 'pink', hex: '#ec4899' },
] as const;

export const DEFAULT_TAG_COLOR = TAG_COLORS[0].hex;
